import { groq } from '#imports';

export function getQuery() {
  return groq`*[_type == "disclaimerSitewide" && !(_id in path('drafts.**'))][0]{
  title,
  text,
  isShowDisclaimer
  }`;
}
